// @spec POL-STR-038
'use client';

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PolicyApprovalConfigPage } from '@/features/policies';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/admin/policies/approval-configs')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.policyApprovalSettings'),
  }),
  component: PolicyApprovalSettingsPage,
});

/**
 * Admin page for managing policy approval configurations.
 *
 * Allows organization admins to:
 * - View all policy approval configurations
 * - Create new configurations for different policy types
 * - Edit existing configurations
 * - Delete configurations
 */
function PolicyApprovalSettingsPage() {
  const { isAdmin } = useOrgRole();
  const { t } = useTranslation('common');

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="mx-auto max-w-4xl">
          <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-center">
            <h2 className="text-lg font-medium text-destructive">{t('accessDenied.title')}</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t('accessDenied.policyApprovalDenied')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <PolicyApprovalConfigPage />;
}
